import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from "../../components/layout/header/Header";

const DashboardPageLayout = () => {
    return (
        <>
            <Header />
            <Outlet />
        </>
    );
}

export default DashboardPageLayout;
